export const MIN_INDEXABLE_PUBLIC_LIST_ITEMS = 3;

interface PublicListSeoInput {
  isPublic: boolean;
  itemCount: number;
}

interface PublicProfileSeoInput {
  bio?: string | null;
  stats: {
    activeListings: number;
  };
  publicLists: Array<{
    itemCount: number;
  }>;
}

export function isIndexablePublicList(input: PublicListSeoInput): boolean {
  return input.isPublic && input.itemCount >= MIN_INDEXABLE_PUBLIC_LIST_ITEMS;
}

export function isIndexablePublicProfile(input: PublicProfileSeoInput): boolean {
  const hasBiography = Boolean(input.bio?.trim());
  const hasActiveListing = input.stats.activeListings > 0;
  const hasSubstantivePublicList = input.publicLists.some(
    (list) => list.itemCount >= MIN_INDEXABLE_PUBLIC_LIST_ITEMS,
  );

  return hasBiography || hasActiveListing || hasSubstantivePublicList;
}
